// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import {useState, useEffect, useCallback, useRef} from 'react';
import {Client} from '../../../shared/ws';

interface i_rt_data_options {
    ws_url: string;
    id: string;
    on_message?: (msg: any)=>void;
}

export const use_rt_data = <T extends object_of<any>>(props:
    i_rt_data_options)=>{
    const {ws_url, id} = props;
    const [is_connected, set_is_connected] = useState(false);
    const [messages, set_messages] = useState<T[]>([]);
    const client_ref = useRef<any | null>(null);
    useEffect(()=>{
        if (!ws_url || !id)
            return;
        const ws_client = new Client({url: ws_url});
        client_ref.current = ws_client;
        ws_client.onmessage = (msg: any)=>{
            try {
                set_messages(prev=>[...prev, msg]);
                props.on_message?.(msg);
            } catch(e){
                console.error('Error processing message:', e);
            }
        };
        ws_client.onopen = ()=>{
            set_is_connected(true);
        };
        ws_client.onclose = ()=>{
            set_is_connected(false);
        };
        return ()=>{
            ws_client.destroy();
            client_ref.current = null;
        };
    }, [ws_url]);
    const send_message = useCallback((m: string, data?: any)=>{
        if (client_ref.current && is_connected)
            client_ref.current.get(m, data);
    }, [is_connected]);
    useEffect(()=>{
        if (is_connected)
            send_message('login', {id});
    }, [is_connected]);
    return {
        client: client_ref.current,
        messages,
        is_connected,
        send_message,
    };
};
